// Func = limiting Scope for this file
var lastScrollTop = 0;

function _get_form_token(){
	$.get(
		'/ajax/functions.php?operation=_get_form_token',
		function(resp) {
			$("input[name=_token][type=hidden]").each( function(){
				this.value = resp
			})
		}
	);
}

(function(){

	_get_form_token();

	$( "form" ).on( "submit", (e) => {
		if( site_url.indexOf( "_concept" ) == "-1" )
			site_url = "";
		console.log( site_url )
	} )

	//scroll down
	if(document.getElementsByClassName('js-scroll').length > 0){
		document.getElementsByClassName('js-scroll')[0].addEventListener('click', function(){
			animateTo('intro');
		})
	}

	//booking CTA
	document.getElementsByClassName('js-booking')[0].addEventListener('click', function(){
		document.getElementsByClassName('booking-block')[0].classList.add('open');
	});
	document.getElementsByClassName('js-close')[0].addEventListener('click', function(){
		document.getElementsByClassName('booking-block')[0].classList.remove('open');
	});


	//menu tablet
	document.getElementsByClassName('js-menu')[0].addEventListener('click', function(){
		if(!this.classList.contains('open')){
			this.classList.add('open');
			this.getElementsByTagName('span')[0].innerHTML = 'Close';
			document.getElementById('primary-nav').classList.add('open');
		} else {
			this.classList.remove('open');
			this.getElementsByTagName('span')[0].innerHTML = 'Menu';
			document.getElementById('primary-nav').classList.remove('open');
		}
	});


	//Intersection for parallax effect
	if(!(window.ActiveXObject) && "ActiveXObject" in window){
		//is explorer
		if(document.getElementsByClassName('toanimate').length > 0 ){
			let alltoanimate = document.getElementsByClassName('toanimate');
			for(let y=0; y < alltoanimate.length; y++){
				alltoanimate[y].classList.add('animate-fade')
				alltoanimate[y].classList.remove('toanimate');
			}
		}
	}else {
		if(document.getElementsByClassName('toanimate').length > 0 ){
			let options = {
				root : null,
				rootMargin : '0px',
				threshold : 0.5
			}
			
			function handlerParallax(entries, observer){
				for(let entry of entries){
					if(entry.isIntersecting){
						entry.target.classList.add('animated');
					} 
				}
			}
			let allparallax = document.getElementsByClassName('toanimate')
			for(let  j = 0; j < allparallax.length; j++ ){
				let observerParallax = new IntersectionObserver(handlerParallax, options)
				observerParallax.observe(allparallax[j])
			}
		}
	}


	$(document).ready(function () {

	

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "mm/dd/yyyy";
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			altField:$("#CheckIn--alt"),
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			altField:$("#CheckOut--alt"),
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		
	});

	window.onload = function() {
		scrollW();
		resizeWindow()
		window.addEventListener('scroll', function(){
			scrollW();
		})
		window.addEventListener('resize', function(){
			resizeWindow();
		});
	};

	document.querySelectorAll('.menu__title').forEach(function(title) {
        title.addEventListener('click', function() {
            const menuItem = title.parentElement.querySelector('.menu__item');
            const allTitles = document.querySelectorAll('.menu__title');
            const allItems = document.querySelectorAll('.menu__item');

            if (title.classList.contains('active')) {
                title.classList.remove('active');
                if (menuItem) menuItem.classList.remove('active');
            } else {
                allTitles.forEach(t => t.classList.remove('active'));
                allItems.forEach(i => i.classList.remove('active'));
                title.classList.add('active');
                if (menuItem) menuItem.classList.add('active');
            }
        });
    });

    document.querySelectorAll('.menu-quad_filter .item-filter').forEach(function(filter) {
        filter.addEventListener('click', function() {
            document.querySelectorAll('.menu-quad_filter .item-filter').forEach(f => f.classList.remove('active'));
            filter.classList.add('active');

            document.querySelectorAll('.menu-quad_menu').forEach(menu => menu.classList.remove('show'));

            const menuValue = filter.getAttribute('data-menu');
            document.querySelectorAll('.menu-quad_menu[data-menu="' + menuValue + '"]').forEach(menu => {
                menu.classList.add('show');
            });
        });
    });

    var firstFilter = document.querySelector('.menu-quad_filter .item-filter');
    if (firstFilter) {
        firstFilter.click();
    }

	//Main Nav Dropdown
	$('ul.submenu').parent().addClass("sub-menu-li");

	$("#primary-nav li.sub-menu-li").hover(
		function () {
			var $submenu = $(this).find("ul.submenu").first();
			$("#primary-nav li.sub-menu-li")
				.removeClass("hover")
				.find("ul.submenu")
				.stop(true, true)
				.fadeOut(200);
			$submenu.stop(true, true).fadeIn(200);
			$(this).addClass("hover");
		},
		function () {
			$(this).find("ul.submenu").stop(true, true).fadeOut(200);
			$(this).removeClass("hover");
		}
	);

	$(document).on("click", function (event) {
		if (!$(event.target).closest("#primary-nav").length) {
			$("#primary-nav li.sub-menu-li")
				.removeClass("hover")
				.find("ul.submenu")
				.fadeOut(200);
		}
	});

}());
function resizeWindow() {
	// vanilla JS window width and height
	var w=window,
	d=document,
	e=d.documentElement,
	g=d.getElementsByTagName('body')[0],
	x=w.innerWidth||e.clientWidth||g.clientWidth,
	y=w.innerHeight||e.clientHeight||g.clientHeight;

	if(x < 1000){
		document.getElementById('primary-nav').classList.add('tablet');
	} else {
		document.getElementById('primary-nav').classList.remove('tablet');
	}
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 100;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

$( ".datepicker_custom" ).datepicker({
	dateFormat: "yy-mm-dd",	
})